import { v4 as uuidv4 } from 'uuid';

export function FormSuccess(props = {}, childrenComponents) {
	return {
		componentName: 'FormSuccess',
		componentId: uuidv4(),
		props: Object.assign({}, props),
		childrenComponents,
	};
}
